<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="chat-window">
    <documentsInfo :acceptorId="acceptorId" :activeMsgItem="activeMsgItem" :acceptorInfo="acceptorInfo"></documentsInfo>
    <msgList :isShow="isShow" ref="msgList" :toUserInfo="toUserInfo" :fromId="fromId" @pretestMsg="pretestMsg" :activeMsgItem="activeMsgItem"></msgList>
    <editor :isShow="isShow" @scrollBottom="scrollBottom" :activeMsgItem="activeMsgItem" @pretestMsg="pretestMsg" @sendMsg="sendMsg"></editor>
  </div>
</template>

<style scoped lang="scss">
  .chat-window{
    min-height: 280px;
  }
</style>
<script>
import documentsInfo from './documents-info.vue'
import msgList from './msg-list.vue'
import editor from './editor.vue'
import mixin from './../mixin'
export default {
  mixins: [ mixin ],
  props: {
    activeMsgItem: {
      type: Object
    },
    isShow: {
      type: Boolean
    },
    acceptorId: {
      type: String
    },
    fromId: {},
    acceptorInfo: {
      type: Object
    },
    toUserInfo: {
      type: Object
    }
  },
  data () {
    // this.sendMsg('aaa')
    // this.$emit('sendMsg', 'msg')
    return {
    }
  },
  components: {
    documentsInfo,
    msgList,
    editor
  },
  methods: {
    sendMsg (msg) {
      this.$emit('sendMsg', msg)
    },
    pretestMsg (msg) {
      this.$emit('pretestMsg', msg)
    },
    scrollBottom () {
      this.$refs.msgList.scrollBottom()
    },
    getHistoryList () {
      this.$refs.msgList.getHistoryList(this.STATUS.INIT)
    }
  }
}
</script>
